<ng-container *ngIf="occurrence; else elseTemplate">
  <div class="report-wrapper">
    <!-- Header student identity -->
    <div class="report-header">
      <i class="material-icons back-btn" (click)="previousStep()">arrow_back</i>
      <div class="report-icon"></div>
      <div class="avatar-block mobile-nodisplay" *ngIf="formation">
        <img class="user-avatar" src="{{defaultAvatar}}" *ngIf="formation.student.user.photo_profile === null">
        <img class="user-avatar" src="{{formation.student.user.photo_profile.thumbnail_150}}"
          *ngIf="formation.student.user.photo_profile !== null">
      </div>
      <div class="user-label" *ngIf="occurrence">
        <div><b translate>teacher.reports.report-title</b> : {{occurrence.student.user.first_name}}
          {{occurrence.student.user.last_name}}</div>
        <div>
          {{occurrence.start | amLocale: 'en' | amDateFormat:'ddd DD MMM, YYYY'}}
          {{occurrence.start | amLocale: 'en' | amDateFormat:'HH:mm'}} - {{occurrence.end | amLocale: 'en' |
          amDateFormat:'HH:mm'}}
        </div>
      </div>
    </div>

    <div class="feedback-wrapper">
      <b class="paragraph-title" translate>teacher.reports.no-show-text<span [ngSwitch]="occurrence.status">
          <!-- Prof Absent -->
          <span *ngSwitchCase="'abs_teacher_without_justification'"
            translate>teacher.report.absent.teacher_without_justification</span>
          <!-- Cours Manqué -->
          <span *ngSwitchCase="'abs_student_without_justification'"
            translate>teacher.report.absent.student_without_justification</span>
        </span>
      </b>
      <div class="feedback-copy">
        <div class="abs_warning_msg" *ngIf="occurrence.status=='abs_teacher_without_justification'"><span
            translate>teacher.reports.abs_teacher_warning_msg</span></div>
        <div class="abs_warning_msg" *ngIf="occurrence.status=='abs_student_without_justification'"><span
            translate>teacher.reports.abs_student_warning_msg</span></div>
      </div>
    </div>

    <div class="feedback-wrapper" *ngIf="occurrence.cancelled_reason">
      <b class="paragraph-title"
        *ngIf="occurrence.status=='abs_student_without_justification'">{{occurrence.student.user.first_name}}
        {{occurrence.student.user.last_name}} :</b>
      <b class="paragraph-title"
        *ngIf="occurrence.status=='abs_teacher_without_justification'">{{occurrence.teacher.user.first_name}}
        {{occurrence.teacher.user.last_name}} :</b>
      <div class="feedback-copy">
        {{occurrence.cancelled_reason}}
      </div>
    </div>
  </div>


</ng-container>

<ng-template #elseTemplate>
  <div class="row center loading pageload-message">
    <b translate>teacher.reports.info-loading</b>
  </div>
</ng-template>